import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GradioConfigService {
  private gradioUrl = new BehaviorSubject<string>(environment.GRADIO_URL || '');
  private isConfigured = new BehaviorSubject<boolean>(!!environment.GRADIO_URL);

  constructor() {
    // Try to load from localStorage
    const savedUrl = localStorage.getItem('gradioUrl');
    if (savedUrl) {
      this.gradioUrl.next(savedUrl);
      this.isConfigured.next(true);
    }
  }

  getGradioUrl(): Observable<string> {
    return this.gradioUrl.asObservable();
  }

  getCurrentGradioUrl(): string {
    return this.gradioUrl.value;
  }

  isGradioConfigured(): Observable<boolean> {
    return this.isConfigured.asObservable();
  }

  setGradioUrl(url: string): void {
    // Save to localStorage
    localStorage.setItem('gradioUrl', url);
    this.gradioUrl.next(url);
    this.isConfigured.next(true);
  }

  reset(): void {
    localStorage.removeItem('gradioUrl');
    this.gradioUrl.next('');
    this.isConfigured.next(false);
  }
} 